import {Component, OnDestroy, OnInit} from '@angular/core';
import {MachinesService} from '../../../services/machines.service';
import {SelectItem} from 'primeng/primeng';
import {Machine} from '../../../models/machine.model';
import {Subject} from 'rxjs/Subject';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../services/authentication.service';

@Component({
  providers: [MachinesService],
  selector: 'app-edit-add',
  templateUrl: './machine.edit.component.html',
})
export class MachineEditComponent implements OnDestroy, OnInit {
  public machineTypes: SelectItem[];
  public machine: Machine;
  public supplyDate: Date;
  public error: string;

  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, private _machineService: MachinesService, public router: Router,
              private _authService: AuthenticationService) {
    this.machineTypes = [];
    this.machineTypes.push({label: 'Compressor', value: 'Compressor'});
    this.machineTypes.push({label: 'Filter', value: 'Filter'});
    this.machineTypes.push({label: 'Droger', value: 'Droger'});
    this.machineTypes.push({label: 'Snelkoppeling', value: 'Snelkoppeling'});
    this.machineTypes.push({label: 'Tank', value: 'Tank'});
  }

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const machineId = params['id'];

        if (machineId) {
          this._machineService.load(machineId);
          this._machineService.machines$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              machines => {
                this.machine = machines.find(pr => pr._id === machineId);
                if (this.machine && this.machine.supplyDate) {
                  this.supplyDate = new Date(this.machine.supplyDate);
                }
              }
            );
        }
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  public saveMachine(): void {
    if (this.machine.name !== '' && this.machine.customer !== '') {
      this.machine.supplyDate = this.supplyDate;
      this._machineService.update(this.machine)
        .subscribe(machine => {
          this.router.navigate(['/machines', this.machine._id]);
        });
    } else {
      this.error = 'Naam is verplicht.';
    }
  }

  public isAdmin(): boolean {
    if (this._authService.user && this._authService.user.role === 'admin') {
      return true;
    }

    return false;
  }

  public cancel(): void {
    this.router.navigate(['/machines', this.machine._id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/machine/edit/machine.edit.component.ts